const baseConfig = {
  API_URL: "",
  LEGACY_RESULTS_BREAKPOINT: new Date("2024-12-31T23:00:00Z"),
}

const envConfigs = {
  "dev-json": {
    API_URL: "http://localhost:3000",
  },
  "dev-django": {
    API_URL: "http://localhost:5173",
    credentials: "include",
  },
  test: {
    API_URL: "repowered.test",
  },
  dev: { credentials: "same-origin" },
  qa: { credentials: "same-origin" },
  prod: { credentials: "same-origin" },
}

export default { ...baseConfig, ...envConfigs[import.meta.env.MODE] }
